module.exports = __webpack_public_path__ + "img/pirates_ship.18d3c63b.png";